const invalidUrls = [
    'https://www.booking.com/pulse',
    'https://www.booking.com/hotel/hoteladmin/extranet_ng/manage/',
    'https://www.booking.com/searchresults',
    'https://account.booking.com/sign-in',
    'https://www.booking.com/index'
];

// Helper function to escape special regex characters
const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Create regex that matches URLs starting with any of the invalid URLs
const invalidUrlsRegex = new RegExp(`^(${invalidUrls.map(escapeRegExp).join('|')})`, 'i');
// eslint-disable-next-line max-len
const urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;

const looksLikeUrlAttempt = (value) => {
    if (!value || typeof value !== 'string') {
        return false;
    }

    const trimmedValue = value.trim();

    // Check for various URL patterns
    const hasHttpProtocol = /^https?:\/\//i.test(trimmedValue);
    const hasWww = /^www\./i.test(trimmedValue);
    const hasDomainPattern = /[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/.test(trimmedValue);

    return hasHttpProtocol || hasWww || hasDomainPattern;
};

/**
 * Validates if a URL is properly formatted and not in the invalid URLs list
 * @param {string} url - The URL to validate
 * @returns {boolean} - Returns true if URL is valid and not in invalid list
 */
const isValidUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return false;
    }

    const trimmedUrl = url.trim();

    // Check if URL matches valid format
    if (!urlRegex.test(trimmedUrl)) {
        return false;
    }

    // Check if URL is not in the invalid URLs list
    return !invalidUrlsRegex.test(trimmedUrl);
};

module.exports = {
    isValidUrl,
    looksLikeUrlAttempt,
    invalidUrlsRegex
};
